<template>
  <div class="login-wrap">
    <div class="logo-wrap">
      <div class="flex flex-row-start" @click="goIndex">
        <img src="@/static/images/top-logo.png" alt="" />
      </div>
    </div>
    <div class="flex flex-row-center form-wrap" :style="{ backgroundImage: 'url(' + bg + ')' }">
      <div class="form-box">
        <div class="form-title">登录</div>
        <el-form :model="formData" :rules="rules" label-position="top" ref="loginFormRef" @submit.native.prevent>
          <el-form-item label="" prop="username">
            <el-input size="large" v-model="formData.username" placeholder="输入用户名">
              <template slot="prepend">
                <i class="el-icon-user-solid"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input size="large" type="password" v-model="formData.password" placeholder="输入密码"
                      @keyup.enter.native="submitHandler">
              <template slot="prepend">
                <i class="el-icon-lock"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item class="check-item">
            <div class="flex flex-row-between">
              <el-checkbox v-model="formData.storage" label="下次自动登录"></el-checkbox>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button class="login-button" type="primary" size="large" @click="submitHandler">登录</el-button>
          </el-form-item>
          <div class="flex flex-row-end">
            <router-link class="register-link" to="/register">还没注册账户？ <span>去注册</span></router-link>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'; // 1. 引入加密库
import { login } from '@/api';

// 2. 定义 AES 密钥 (必须与注册页、后端完全一致)
const AES_KEY = "xVjzymyDzUN8dk0W";

export default {
  name: 'Login',
  components: {},
  data() {
    return {
      bg: require('@/static/images/login/bg.png'),
      formData: {
        username: undefined,
        password: undefined,
        storage: false // 建议给个默认值
      },
      rules: {
        // 5. 修正了这里的提示文案，原代码写的是“请输入密码”
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    };
  },
  methods: {
    goIndex() {
      this.$router.push('/');
    },

    // 3. 添加 AES 加密方法
    encryptByAES(message) {
      const key = CryptoJS.enc.Utf8.parse(AES_KEY);
      const srcs = CryptoJS.enc.Utf8.parse(message);
      const encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },

    // 4. 修改提交逻辑
    submitHandler() {
      this.$refs['loginFormRef'].validate((valid) => {
        if (valid) {
          const { storage, username, password } = this.formData;


          // --- 本地存储逻辑 (存的是明文，用于下次自动填充) ---
          if (storage) {
            window.localStorage.setItem('login', JSON.stringify(this.formData));
          } else {
            const storageLogin = window.localStorage.getItem('login');
            if (storageLogin) {
              const localStorage = JSON.parse(storageLogin || '') || {};
              if (username && username === localStorage.username) {
                window.localStorage.removeItem('login');
              }
            }
          }

          // --- 登录接口调用逻辑 (发送的是密文) ---

          // 1. 加密账号
          const encryptedUsername = this.encryptByAES(username);
          // 2. 加密密码
          const encryptedPassword = this.encryptByAES(password);

          const reqData = {
            username: encryptedUsername, // ★★★ 发送密文
            password: encryptedPassword  // ★★★ 发送密文
          };

          login(reqData).then((res) => {
            const { accessToken } = res;
            this.$store.dispatch('setToken', accessToken);
            this.$router.push('/');
          });
        } else {
          console.log('校验不通过');
          return false;
        }
      });
    }
  },
  created() { },
  mounted() {
    const storageLogin = window.localStorage.getItem('login');
    if (storageLogin) {
      // 还原存储的信息（包含明文密码）
      this.$set(this, 'formData', JSON.parse(storageLogin));
    }
  }
};
</script>

<style lang='scss'>
@import './login.scss';

.el-checkbox {
  .el-checkbox__inner {
    &:hover {
      border-color: #d01c0b;
    }
  }

  &.is-checked {
    .el-checkbox__inner {
      background-color: #d01c0b;
      border-color: #d01c0b;

      &:hover {
        border-color: #d01c0b;
      }
    }

    .el-checkbox__label {
      color: #d01c0b;
    }
  }

  .el-checkbox__input {
    &.is-focus {
      .el-checkbox__inner {
        &:hover {
          border-color: #d01c0b;
        }
      }
    }
  }
}
</style>
